import React, { Children } from 'react'
import { bool, string, number, oneOf, node } from 'prop-types'
import classnames from 'classnames'

import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Label from 'components/atoms/Label'

const FormGroup = ({
  alert,
  showAlert,
  id,
  labelSize,
  labelPosition,
  labelText,
  className,
  gridSize,
  required,
  children,
}) => {
  const isInline = labelPosition === 'inline'
  const FormGroupDiv = isInline ? Row : 'div'
  const FormGroupPart = isInline ? Col : 'div'
  const gridPropLabel = isInline ? { [gridSize]: labelSize } : {}
  const gridPropInput = isInline ? { [gridSize]: 12 - labelSize } : {}

  const clonedChildren = Children.map(children, child => (
    React.cloneElement(
      child,
      { id },
    )
  ))

  return (
    <FormGroupDiv className={classnames('form-group', className)}>
      <FormGroupPart {...gridPropLabel}>
        <Label className="form-group__label" htmlFor={id}>
          { labelText }
          { required && <span className="required">*</span> }
        </Label>
      </FormGroupPart>
      <FormGroupPart {...gridPropInput}>
        { showAlert && alert }
        { clonedChildren }
      </FormGroupPart>
      <style jsx>
        {`
          .form-group {
            margin-bottom: 1rem;
            .required {
              color: #ff0000;
            }
          }
        `}
      </style>
    </FormGroupDiv>
  )
}

FormGroup.propTypes = {
  alert: node,
  showAlert: bool,
  id: string,
  labelSize: number,
  labelPosition: oneOf(['block', 'inline']),
  labelText: string,
  className: string,
  gridSize: string,
  required: bool,
}

FormGroup.defaultProps = {
  labelPosition: 'block',
  labelSize: 2,
  gridSize: 'md',
  showAlert: false,
}

export default FormGroup
